// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BLOCKED_COMMENT_PLACEHOLDER = "Skryt\u00fd koment\u00e1\u0159 od zablokovan\u00e9ho u\u017eivatele";
export const BLOCKED_REPLY_PLACEHOLDER = "Odpov\u011b\u010f na skryt\u00fd koment\u00e1\u0159";
export const FORUM_COMMENT_REMOVE_COMPLAINTS = "Zru\u0161 nahl\u00e1\u0161en\u00ed odpov\u011bdi";
